<template>
  <base-page v-if="currentUser.role != 'user'">
    <sw-page-header :title="$t('documents.title')">
      <sw-breadcrumb slot="breadcrumbs">
        <sw-breadcrumb-item to="dashboard" :title="$t('general.home')" />

        <sw-breadcrumb-item
          to="#"
          :title="$tc('documents.document', 2)"
          active
        />
      </sw-breadcrumb>

      <template slot="actions">
        <sw-button
          v-show="totalDocuments"
          size="lg"
          variant="primary-outline"
          @click="toggleFilter"
        >
          {{ $t('general.filter') }}
          <component :is="filterIcon" class="w-4 h-4 ml-2 -mr-1" />
        </sw-button>
      
      </template>
    </sw-page-header>

    <slide-y-up-transition>
      <sw-filter-wrapper
        v-if="currentUser.role != 'user'"
        v-show="showFilters"
        class="relative grid grid-flow-col grid-rows"
      >
        <sw-input-group :label="$tc('documents.user', 1)" class="mt-2">
          <base-customer-select
            ref="userSelect"
            @select="onSelectUser"
            @deselect="clearUserSearch"
          />
        </sw-input-group>

        <sw-input-group :label="$t('documents.status')" class="mt-2 xl:mx-8">
          <sw-select
            v-model="filters.status"
            :options="status"
            :searchable="true"
            :show-labels="false"
            :allow-empty="false"
            label="name"
            :placeholder="$t('general.select_a_status')"
            @select="setActiveTab"
            @remove="clearStatusSearch()"
          />
        </sw-input-group>

        <sw-input-group
          :label="$t('documents.date')"
          color="black-light"
          class="mt-2"
        >
          <base-date-picker
            v-model="filters.date_delivrance"
            :calendar-button="true"
            calendar-button-icon="calendar"
          />
        </sw-input-group>
        <!-- <sw-input-group
          :label="$t('documents.ref')"
          color="black-light"
          class="mt-2 xl:ml-8"
        >
          <sw-input v-model="filters.document_number">
            <hashtag-icon slot="leftIcon" class="h-5 ml-1 text-gray-500" />
          </sw-input>
        </sw-input-group> -->

        <label
          class="absolute text-sm leading-snug text-black cursor-pointer"
          style="top: 10px; right: 15px"
          @click="clearFilter"
          >{{ $t('general.clear_all') }}</label
        >
      </sw-filter-wrapper>
    </slide-y-up-transition>

    <sw-empty-table-placeholder
    
      v-show="showEmptyScreen"
      :title="$t('documents.no_documents')"
      :description="$t('documents.list_of_documents')"
    >
      <moon-walker-icon class="mt-5 mb-4" />

    </sw-empty-table-placeholder>
    <sw-dropdown right split text="Split Menu">
        <sw-dropdown-item>Item 1</sw-dropdown-item>
        <sw-dropdown-item>Item 2</sw-dropdown-item>
        <sw-dropdown-divider></sw-dropdown-divider>
        <sw-dropdown-item>Item 3</sw-dropdown-item>
    </sw-dropdown>
 
    <div v-show="!showEmptyScreen" class="relative table-container">
      <div class="relative flex items-center justify-between h-10 mt-5 list-none border-b-2 border-gray-200 border-solid ">
        <p class=" text-sm" style="top: 50px">
          {{ $t('general.showing') }}: <b>{{ documents.length }}</b>
          {{ $t('general.of') }} <b>{{ totalDocuments }}</b>
        </p>

        <!-- Tabs -->
        <!-- <sw-tabs
          :active-tab="activeTab"
          class="mb-10"
          @update="setStatusFilter"
        >
          <sw-tab-item :title="$t('general.draft')" filter="DRAFT" />
          <sw-tab-item :title="$t('documents.accepted')" filter="ACCEPTED" />
          <sw-tab-item :title="$t('general.sent')" filter="SENT" />
          <sw-tab-item :title="$t('general.all')" filter="" />
        </sw-tabs> -->

        <!-- <sw-transition type="fade">
          <sw-dropdown
            v-if="selectedDocuments.length"
            class="absolute float-right"
            style="margin-top: -70px"
          >
            <span
              slot="activator"
              class="flex block text-sm font-medium cursor-pointer select-none text-primary-400"
            >
              {{ $t('general.actions') }}
              <chevron-down-icon class="h-5" />
            </span>

            <sw-dropdown-item @click="removeMultipleDocuments">
              <trash-icon class="h-5 mr-3 text-gray-600" />
              {{ $t('general.delete') }}
            </sw-dropdown-item>
          </sw-dropdown>
        </sw-transition> -->
      </div>

      <div
        v-show="documents && documents.length"
        class="absolute z-10 items-center pl-4 mt-2 select-none md:mt-6"
      >
        
      </div>

      <sw-table-component
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <sw-table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
         <span></span>
        </sw-table-column>

       <sw-table-column
          :sortable="true"
          sort-as="name"
          filter-as="name"
          :label="$t('documents.partenaire')"

        >
        <template slot-scope="row">
          <span>{{ $t('documents.partenaire') }}</span>
          <router-link
            :to="{ path: `documents/${row.user_id}/view/${row.id}` }"
            class="font-medium text-primary-500"
          >
            {{row.name}}
          </router-link>
        </template>

      </sw-table-column>

        <sw-table-column
          :sortable="false"
          :label="$t('documents.nb_draft')"
        >
          <template slot-scope="row">
            <span> {{ $t('documents.nb_draft') }}</span>
            {{row.partenaire.totalDraftDocuments}}
          </template>
        </sw-table-column>

         <sw-table-column
          :sortable="false"
          :label="$t('documents.nb_accepted')"
        >
          <template slot-scope="row">
            <span> {{ $t('documents.nb_accepted') }}</span>
            {{row.partenaire.totalAcceptedDocuments}}
          </template>
        </sw-table-column>

        <sw-table-column
          :sortable="false"
          :label="$t('documents.nb_rejected')"
        >
          <template slot-scope="row">
            <span> {{ $t('documents.nb_rejected') }}</span>
            {{row.partenaire.totalRejectedDocuments}}
          </template>
        </sw-table-column>

        <sw-table-column
          :sortable="false"
          :label="$t('documents.nb_expired')"
        >
          <template slot-scope="row">
            <span> {{ $t('documents.nb_expired') }}</span>
            {{row.partenaire.totalExpiredDocuments}}
          </template>
        </sw-table-column>

        <sw-table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t('documents.action') }} </span>
            <sw-dropdown containerClass="w-56">
              <dot-icon slot="activator" />

              <sw-dropdown-item
                tag-name="router-link"
                :to="{ path: `documents/${row.user_id}/view/${row.id}` }"
              >
                <eye-icon class="h-5 mr-3 text-gray-600" />
                {{ $t('general.view') }}
              </sw-dropdown-item>

      
              <!-- <sw-dropdown-item
                v-if="row.status !== 'ACCEPTED'"
                @click="onMarkAsAccepted(row.id)"
              >
                <check-circle-icon class="h-5 mr-3 text-gray-600" />
                {{ $t('documents.mark_as_accepted') }}
              </sw-dropdown-item>

              <sw-dropdown-item
                v-if="row.status !== 'REJECTED'"
                @click="onMarkAsRejected(row.id)"
              >
                <x-circle-icon class="h-5 mr-3 text-gray-600" />
                {{ $t('documents.mark_as_rejected') }}
              </sw-dropdown-item> -->
            </sw-dropdown>
          </template>
        </sw-table-column>
      </sw-table-component>
    </div>
  </base-page>

  <base-page v-else>
     <sw-page-header :title="$t('documents.title')">
      <sw-breadcrumb slot="breadcrumbs">
        <sw-breadcrumb-item to="dashboard" :title="$t('general.home')" />

        <sw-breadcrumb-item
          to="#"
          :title="$tc('documents.document', 2)"
          active
        />
      </sw-breadcrumb>
    </sw-page-header>

     
    <sw-table-component
      ref="table"
      :show-filter="false"
      :data="fetchUserData"
      table-class="table"
    >
      <sw-table-column
        :sortable="false"
        :filterable="false"
        cell-class="no-click"
      >
        <div class="flex items-center">
          
        </div>
      </sw-table-column>
      <sw-table-column
        :sortable="true"
        sort-as="name"
        :label="$t('documents.type')"
        show="name"

      >
        <template slot-scope="row">
          <span>{{ $t('documents.type') }}</span>
           <router-link
            v-if="row.documents.length > 0"
            :to="{ path: `documents/${row.documents[0].id}/view` }"
            class="font-medium text-primary-500"
          >
            <span class="text-center">{{row.name}}</span>
          </router-link>
          <span v-else class="text-center">{{row.name}}</span>
        </template>
      </sw-table-column>
      <sw-table-column
        :sortable="true"
        sort-as="validity"
        :label="$t('document_types.validity')"
        show="validity"

      >
        <template slot-scope="row">
          <span>{{ $t('document_types.validity') }}</span>
          <span class="text-center">{{row.validity != -1 ? row.validity :  'Toujours'}}</span>
        </template>
      </sw-table-column>

      <sw-table-column
        :sortable="true"
        :label="$tc('documents.status', 1)"
        show="status"
      >
        <template slot-scope="row">
            
          <span>{{ $tc('documents.status', 1) }}</span>
                 
          <sw-badge
            v-if="row.documents.length > 0"
            :bg-color="$utils.getBadgeStatusColor(row.documents[0].status).bgColor"
            :color="$utils.getBadgeStatusColor(row.documents[0].status).color"
            class="px-3 py-1"
          >
            {{ $utils.getStatusTranslation(row.documents[0].status) }}
          </sw-badge>

        </template>
      </sw-table-column>
        <sw-table-column
          :sortable="false"
          :label="$t('documents.date')"
        >
        <template slot-scope="row">              
            <span>{{ $t('documents.date') }}</span>            
            {{ row.documents.length > 0 ? row.documents[0].formattedDateDelivrance : '' }}
          </template>
        </sw-table-column>  
        <sw-table-column
          :sortable="false"
          :label="$t('documents.days_left')"
        >
        <template slot-scope="row">              
            <span>{{ $t('documents.days_left') }}</span>            
            {{ row.documents.length > 0 && row.validity != -1 ? calcDaysLeft(row) : '' }}
          </template>
        </sw-table-column>  
        <sw-table-column
          :sortable="false"
          :label="$t('general.actions')"
          header-class="text-center"
        >
        <template slot-scope="row">     
            <span>{{$t('general.actions')}}</span>
            <div class="flex justify-center">                   
            <sw-dropdown-item
                v-if="!row.documents[0]"
                @click="addDocument(row.name,row.id)">
                <plus-circle-icon class="h-5 text-gray-600" />
            </sw-dropdown-item>
            <sw-dropdown-item
              v-if="row.documents[0]"
              @click="editDocument(row.name,row.documents[0].id)"
            >
                <pencil-icon class="h-5 mr-3 text-gray-600" />
            </sw-dropdown-item>
            <sw-dropdown-item
               v-if="row.documents[0]"
               @click="removeDocument(row.documents[0].id)">
                <trash-icon class="h-5  text-gray-600" />
              </sw-dropdown-item>
               <sw-dropdown-item
                 v-if="row.documents[0]"
                tag-name="router-link"
                :to="{ path: `documents/${row.documents[0].id}/view` }"
              >
                <eye-icon class="h-5 mr-3 text-gray-600" />
              </sw-dropdown-item>
            </div>
          </template>
        </sw-table-column>  

        <sw-table-column>  
            <template >
                <span></span>  
            </template>
        </sw-table-column>    

      </sw-table-component>

  </base-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Permissions from '../../stub/permissions'
import Ls from '../../services/ls'
import DocumentRow from "./partials/DocumentRow.vue"
import MoonWalkerIcon from '@/components/icon/MoonwalkerIcon'
import {
  PlusIcon,
  CalculatorIcon,
  DocumentIcon,
  FilterIcon,
  XIcon,
  ChevronDownIcon,
  EyeIcon,
  XCircleIcon,
  DocumentTextIcon,
  PaperAirplaneIcon,
  CheckCircleIcon,
  TrashIcon,
  PencilIcon,
  HashtagIcon,
   TruckIcon,
    ViewGridAddIcon,
    CloudUploadIcon,
  LightBulbIcon,
  
} from '@vue-hero-icons/solid'

import { DotsHorizontalIcon, 
  PlusCircleIcon
 } from '@vue-hero-icons/outline'

export default {
  components: {
    MoonWalkerIcon,
    CalculatorIcon,
    DotsHorizontalIcon,
    DocumentIcon,
    PlusIcon,
    FilterIcon,
    XIcon,
    ChevronDownIcon,
    PencilIcon,
    TrashIcon,
    CheckCircleIcon,
    PaperAirplaneIcon,
    DocumentTextIcon,
    XCircleIcon,
    EyeIcon,
    HashtagIcon,
    TruckIcon,
    ViewGridAddIcon,
    LightBulbIcon,
    CloudUploadIcon,
    DocumentRow,
    PlusCircleIcon
  },

  data() {
    return {
      showFilters: false,
      currency: null,
      previewReceipt: null,
      newDocument : [{
          date_delivrance :null,
          type_id : null,
          attachment : null,
          fileObject : null,
          status : ''
      }],
      status: [
        { id : 'DRAFT', name:this.$t('general.draft') },
        { id : 'ACCEPTED', name: this.$t('general.accepted') }, 
        { id : 'REJECTED', name: this.$t('general.rejected')},
        { id : 'EXPIRED', name: this.$t('general.expired')}
      ],
      isRequestOngoing: true,
      activeTab: this.$t('general.draft'),
      closed :false,
      helpDecision : false,
      permissionsStub : Permissions,

      filters: {
        user: '',
        status: {id: '', name : ''},
        date_delivrance: '',
      },
      my_documents : [],
    }
  },

  created() {
    this.permissionsStub = Permissions
   
  },

  computed: {
    showEmptyScreen() {
        console.log(this.totalDocuments)
        console.log(this.isRequestOngoing)
      return !this.totalDocuments && !this.isRequestOngoing
    },

    filterIcon() {
      return this.showFilters ? 'x-icon' : 'filter-icon'
    },

    ...mapGetters('users', ['users']),

    ...mapGetters('document', [
      'selectedDocuments',
      'totalDocuments',
      'documents',
      'selectAllField',
    ]),

    ...mapGetters('user', ['currentUser','userPermissions']),
   
    selectField: {
      get: function () {
        return this.selectedDocuments
      },
      set: function (val) {
        this.selectDocument(val)
      },
    },

    selectAllFieldStatus: {
      get: function () {
        return this.selectAllField
      },
      set: function (val) {
        this.setSelectAllState(val)
      },
    },
  },

  watch: {
    filters: {
      handler: 'setFilters',
      deep: true,
    },
  },

  destroyed() {
    if (this.selectAllField) {
      this.selectAllDocuments()
    }
  },

  methods: {
    ...mapActions('document', [
      'fetchDocuments',
      'fetchDocument',
      'fetchMyDocuments',
      'resetSelectedDocuments',
      'selectDocument',
      'selectAllDocuments',
      'deleteDocument',
      'deleteMultipleDocuments',
      'setSelectAllState',
      'markAsAccepted',
      'markAsRejected',
    ]),

    ...mapActions('modal', ['openModal']),
    
    addDocument(name,id) {
      this.openModal({
        title: this.$t('documents.add_new_document') +' de type '+name ,
        componentName: 'DocumentModal',
        data : {type_id : id},
        refreshData: this.$refs.table.refresh,
      })
    },

    async editDocument(name,id) {
      let response = await this.fetchDocument(id)
      let document = response.data.document
      this.openModal({
        title: this.$t('documents.edit_document')+ ' de type '+name,
        componentName: 'DocumentModal',
        id: id,
        data: {document , type_id : document.type_document_id},
        refreshData: this.$refs.table.refresh,
      })
    },

    calcDaysLeft(typeDoc) {
      let validity = typeDoc.validity
      let days_lefts =  moment().diff(moment(typeDoc.documents[0].date_delivrance, "YYYY-MM-DD"), 'days')
      let diff = 0
      diff = validity - days_lefts
      // let date_fin = moment(typeDoc.documents[0].date_delivrance, "YYYY-MM-DD").add(validity, 'days')
      // diff = date_fin.diff(moment(), 'days')
      // console.log(date_fin.format( "YYYY-MM-DD"))
      console.log(diff)
      if(diff < 0)
        diff =0
      
      return diff
    },

    refreshTable() {
      this.$refs.table.refresh()
    },
    initialiseDocuments (){
        Promise.all([
          this.fetchDocumentTypes(),
          this.fetchMyDocuments()
        ])
        .then(async([res1,res2]) => {

          this.my_documents = res2.data.documents
            console.log(res2)
        })
        .catch((error) => {
          console.log(error)
        })
        // if(this.currentUser.role == 'user') {
        //    let res = await this.fetchMyDocuments()
        //    this.my_documents = res.data.documents
        //     console.log(res)
        // }
        // console.log(this.documents)
        
    },

    loadDocument(id) {
        let res = null
        Promise.all([this.fetchMyDocuments({
            type_document_id : id
        })
        ]).then(async([response]) => {
            console.log(response)
            return {
              data : response.data.documents[0]
            }

        })
    },
    getDocument(id) {
        let doc = this.my_documents.filter((item) => {
            return item.type_document_id == id
        });
        console.log(id)
        console.log(doc)
        if(doc[0]){
            console.log(doc[0])
            return doc[0]
        }
        else return null
    },

    async fetchUserData({ page, filter, sort }) {
       let data = {
        orderByField: sort.fieldName || 'created_at',
        orderBy: sort.order || 'desc',
        page,
      }
      this.isRequestOngoing = true
      let response = await this.fetchMyDocuments(data)
      console.log(response.data)
      this.isRequestOngoing = false

      return {
        data: response.data.documents.data,
        pagination: {
          totalPages: response.data.documents.last_page,
          currentPage: page,
          count: response.data.documents.count,
        },
      }
    },

    async fetchData({ page, filter, sort }) {

      let data = {
        user_id:
          this.filters.user === ''
            ? this.filters.user
            : this.filters.user.id,
        status: this.filters.status.id,
        date_delivrance: this.filters.date_delivrance,
        orderByField: sort.fieldName || 'created_at',
        orderBy: sort.order || 'desc',
        page,
      }

      this.isRequestOngoing = true
      let response = await this.fetchDocuments(data)
      console.log(response.data)
      this.isRequestOngoing = false


      return {
        data: response.data.documents.data,
        pagination: {
          totalPages: response.data.documents.last_page,
          currentPage: page,
          count: response.data.documents.count,
        },
      }
    },

    setStatusFilter(val) {
      if (this.activeTab == val.title) {
        return true
      }
      this.activeTab = val.title
      switch (val.title) {
        case this.$t('general.draft'):
          this.filters.status = {id:'DRAFT'}
          break
        case this.$t('general.sent'):
          this.filters.status = {id:'SENT'}
          break
        case this.$t('documents.accepted'):
          this.filters.status = {id:'ACCEPTED'}
          break
        default:
          this.filters.status = {id:''}
          break
      }
    },

    async onMarkAsAccepted(id) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('documents.confirm_mark_as_accepted'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true,
      }).then(async (markedAsRejected) => {
        if (markedAsRejected) {
          const data = {
            id: id,
            status: 'ACCEPTED',
          }

          let response = await this.markAsAccepted(data)

          if (response.data) {
            this.$refs.table.refresh()
            window.toastr['success'](
              this.$tc('documents.marked_as_accepted_message')
            )
          }
        }
      })
    },

    async onMarkAsRejected(id) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('documents.confirm_mark_as_rejected'),
        icon: '/assets/icon/times-circle-solid.svg',
        buttons: true,
        dangerMode: true,
      }).then(async (markedAsRejected) => {
        if (markedAsRejected) {
          const data = {
            id: id,
            status: 'REJECTED',
          }

          let response = await this.markAsRejected(data)

          if (response.data) {
            this.$refs.table.refresh()
            window.toastr['success'](
              this.$tc('documents.marked_as_rejected_message')
            )
          }
        }
      })
    },

    setFilters() {
      this.resetSelectedDocuments()
      this.$refs.table.refresh()
    },

    clearFilter() {
      if (this.filters.user) {
        this.$refs.userSelect.$refs.baseSelect.removeElement(
          this.filters.user
        )
      }

      this.filters = {
        user: '',
        status: {id: '', name : ''},
        date_delivrance: '',
        to_date: '',
        document_number: '',
      }

      this.activeTab = this.$t('general.all')
    },

    toggleFilter() {
      if (this.showFilters) {
        this.clearFilter()
      }

      this.showFilters = !this.showFilters
    },

    onSelectUser(user) {
      this.filters.user = user
    },

    async removeDocument(id) {
      this.id = id
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('documents.confirm_delete', 1),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          let res = await this.deleteDocument({ ids: [this.id] })

          if (res.data.success) {
            this.$refs.table.refresh()
            // this.resetSelectedDocuments()
            window.toastr['success'](this.$tc('documents.deleted_message', 1))
          } else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },

    async convertInToinvoice(id) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('documents.confirm_conversion'),
        icon: '/assets/icon/file-alt-solid.svg',
        buttons: true,
        dangerMode: true,
      }).then(async (willConvertInToinvoice) => {
        if (willConvertInToinvoice) {
          let res = await this.convertToInvoice(id)

          if (res.data) {
            window.toastr['success'](this.$t('documents.conversion_message'))
            this.$router.push(`invoices/${res.data.invoice.id}/view`)
          } else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },

    async removeMultipleDocuments() {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('documents.confirm_delete', 2),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          let res = await this.deleteMultipleDocuments()

          if (res.data.success) {
            this.$refs.table.refresh()
            this.resetSelectedDocuments()
            window.toastr['success'](this.$tc('documents.deleted_message', 2))
          } else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },

    async clearUserSearch(removedOption, id) {
      this.filters.user = ''
      this.refreshTable()
    },

    async clearStatusSearch(removedOption, id) {
      this.filters.status = {id: '', name: ''}
      console.log(this.filters.status)
      this.activeTab = this.$t('general.all')
      this.refreshTable()
    },

    async onMarkAsSent(id) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('documents.confirm_mark_as_sent'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true,
      }).then(async (willMarkAsSent) => {
        if (willMarkAsSent) {
          const data = {
            id: id,
            status: 'SENT',
          }

          let response = await this.markAsSent(data)
          this.refreshTable()

          if (response.data) {
            window.toastr['success'](
              this.$tc('documents.mark_as_sent_successfully')
            )
          }
        }
      })
    },
    async sendDocument(Document) {
      this.openModal({
        title: this.$t('documents.send_document'),
        componentName: 'SendDocumentModal',
        id: document.id,
        data: document,
        variant: 'lg',
      })
    },
    setActiveTab(val) {
      switch (val.name) {
        case this.$t('general.draft'):
          this.activeTab = this.$t('general.draft')
          break
        case this.$t('general.sent'):
          this.activeTab = this.$t('general.sent')
          break
        case this.$t('documents.accepted'):
          this.activeTab = this.$t('documents.accepted')
          break
        default:
          this.activeTab = this.$t('general.all')
          break
      }
    },
  },
}
</script>
